import React from 'react';
import { Filter, SelectInput, TextInput } from 'react-admin';
import { PROVIDER_STATUSES, COUNTRIES } from '../../constants';

const ProvidersFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <TextInput label="Last Name" source="last_name" allowEmpty />
    <TextInput label="First Name" source="first_name" allowEmpty />
    <SelectInput source="country" choices={COUNTRIES} />
    <SelectInput source="status" choices={PROVIDER_STATUSES} />
  </Filter>
);

export default ProvidersFilter;
